import  React from "react";

export function SundayRunClubIcon(props: any) {
  return (
    <svg viewBox="0 0 151.76 128.51" {...props}>
      <g data-name="Layer 2">
        <path
          d="M8.53 112.9c8.43 7.27 21 12.23 32.66 14.94 3.53 1.1 38.15.92 21.81-4.14a56.8 56.8 0 01-17.29-10.11c16.54 1.5 36.78-5.15 47.1-11.6-7.09-2.77-6.41-1.84-15.06-4.74-3.11-1.06-3.29-1.47-.19-2.23C84 93.55 103 91.58 116.21 79.17c2.7-2.5 12.79-13 7.92-11-4.7 2.85-7.92 3.84-13.63 4.82-5.87 1.07-16.1 2.28-24 .79 18.24-2.72 37.72-14.66 50-32.65 1.72-2.64 2.52-4.19.38-3.21C126.41 44 109 49.52 97.27 49.18 117 39 139.17 26.76 151 2.81c1.17-2.37.89-3.68-1.35-1.76-36.4 22.65-97 54.15-137.49 77.28-14.29 9.05-16.3 23.78-3.63 34.57z"
          fill="#00301b"
          stroke="#343434"
          strokeMiterlimit={10}
          strokeWidth={0.25}
          data-name="Layer 1"
        />
      </g>
    </svg>
  )
};